import { Component } from '@angular/core';
import { FormArray, FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-multi-lineitems',
  templateUrl: './multi-lineitems.component.html',
  styleUrls: ['./multi-lineitems.component.scss']
})
export class MultiLineitemsComponent {
  rfqForm!: FormGroup;	
  resetFileUpload = false;
  documentInfo: any = {
      userType: '',
      documentUseFor: '',
      baseUrl: '',
  };
  fileUploadConfig = {
      uploadLabel: '',
      buttonName: 'Choose File',
      dragDropText: 'Drag & Drop File or',
      isMultiple: false,
      fileSizeLimit: 10485760 * 10, // 100 mb in bytes
      fileLocation: '',
      fileFormats:
        '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt, .png, .jpeg, .jpg', // supported file formats for file picker
  };
  constructor(private fb:FormBuilder ){
    
  }
	ngOnInit(): void {
    this.rfqForm = this.fb.group({
      lineItems: this.fb.array([this.createLineItem()])
    });

    for (let index = 0; index < 3; index++) {
      this.addLineItem();
    }
  }

	lineItems(): FormArray {
    return this.rfqForm.get('lineItems') as FormArray;
  }

  getSubLineItems(i: number): FormArray {
    return this.lineItems().at(i).get('subItems') as FormArray;
  }

  createLineItem(): FormGroup {
    return this.fb.group({
      selected: [false],
      partName: ['Indirect'],
      partCode: ['A123'],
      partDescription: ['Abrasive Wheels'],
      commodity: ['Aluminum'],
      fileType: ['Yes'],
      attachment: [null],
      customerMOQ: ['1000'],
      orderType: ['One Time'],
      annualReq: ['5000'],
      subItems: this.fb.array([])
    });
  }

  createSubLineItem(): FormGroup {
    return this.fb.group({
      subPartName: [''],
      subPartCode: [''],
      subDescription: [''],
      subCommodity: ['Aluminum'],
      subFileType: ['Yes'],
      subAttachment: [null],
      subCustomerMOQ: ['1000'],
      subOrderType: ['One Time'],
      subAnnualReq: ['5000'],
    });
  }

  addLineItem(): void {
    this.lineItems().push(this.createLineItem());
  }

  addSubLineItem(i: number): void {
    this.getSubLineItems(i).push(this.createSubLineItem());
  }

  deleteLineItem(index: number): void {
    if (this.lineItems().length > 1) {
      this.lineItems().removeAt(index);
    }
  }

  removeSubLineItem(parentIndex: number, childIndex: number): void {
    this.getSubLineItems(parentIndex).removeAt(childIndex);
  }

  toggleSelectAll(event: any) {
    const isChecked = event.target.checked;
    this.lineItems().controls.forEach(ctrl => {
      ctrl.get('selected')?.setValue(isChecked);
    });
  }
  toggleSelectSingle(event: any){
    const isChecked = event.target.checked;
  }
  
  isAllSelected(): boolean {
    return this.lineItems.length > 0 && this.lineItems().controls.every(ctrl => ctrl.get('selected')?.value);
  }
  
  getSelectedRows() {
    const selected = this.lineItems().controls
      .filter(ctrl => ctrl.get('selected')?.value)
      .map(ctrl => ctrl.value);
    console.log('Selected Rows:', selected);
    return selected;
  }

  onSubmit(): void {
    console.log(this.rfqForm.value);
  }
  fileUploadEvent(fileUploadEvent: any): void {}
}
